import { Loader2 } from "lucide-react";
import { cn } from "~/lib/utils";

interface Props {
  className?: string;
}

const Loading = ({ className }: Props) => {
  return (
    <div className={cn("text-center", className)}>
      <Loader2 className="inline-block h-8 w-8 animate-spin text-primary-400" />
    </div>
  );
};
export default Loading;
